import React from "react";
import { Modal, Space, Divider, Group, Button, Text } from "@mantine/core";
import { OdpBlockedDateContextType } from "../../@types/blockedDates";
import { OdpBlockedDatesContext } from "../../providers/BlockedDatesProvider";

type Props = {
  isDeleteBlockedDatesModalOpened: boolean;
  setIsDeleteBlockedDatesModalOpened: (val: boolean) => void;
  setOpenedConfirmationBlockedDatesModal: (val: boolean) => void;
};
const DeleteBlockedDatesModal: React.FC<Props> = ({
  isDeleteBlockedDatesModalOpened,
  setIsDeleteBlockedDatesModalOpened,
  setOpenedConfirmationBlockedDatesModal,
}) => {
  const {
    deleteBlockDate,
    currentBlockedDate,
    updateOrCreateEmployeesBlockedDates,
  } = React.useContext(OdpBlockedDatesContext) as OdpBlockedDateContextType;

  const deleteButtonOnClick = (): void => {
    if (
      currentBlockedDate.employees &&
      currentBlockedDate.employees.length > 0
    ) {
      updateOrCreateEmployeesBlockedDates({
        employeesCreate: [],
        employeesDelete: currentBlockedDate.employees,
        blockedDateId: currentBlockedDate.id,
      });
    } else {
      deleteBlockDate(currentBlockedDate.id);
    }
    setIsDeleteBlockedDatesModalOpened(false);
    setOpenedConfirmationBlockedDatesModal(true);
  };
  return (
    <Modal
      size="lg"
      withCloseButton={false}
      opened={isDeleteBlockedDatesModalOpened}
      closeOnClickOutside={false}
      centered
      onClose={() => {
        setIsDeleteBlockedDatesModalOpened(false);
        setOpenedConfirmationBlockedDatesModal(true);
      }}
      style={{ textAlign: "center" }}
    >
      <div style={{ padding: "0 20px 30px 20px" }}>
        <Text
          size="xl"
          style={{
            marginTop: "30px",
            fontSize: "18px",
            fontWeight: 700,
            lineHeight: "24.59px",
          }}
        >
          Permanently delete your blocked date
        </Text>

        <Text size="xs" weight={400} mt={12}>
          This blocked date will be permanently deleted. The blocked dates you
          had set will no longer apply to your employees’ transaction blocks.
        </Text>

        <Text size="xs" weight={400} mt={28}>
          Are you sure you want to delete your blocked date?
        </Text>

        <Space h="md" />

        <Divider my="sm" />
        <Space h="md" />

        <Group spacing="xl" position="center">
          <Button
            onClick={() => setIsDeleteBlockedDatesModalOpened(false)}
            variant="outline"
            style={{
              height: "40px",
              padding: "0 20px",
              width: "150px",
            }}
          >
            No, Keep On
          </Button>
          <Button
            onClick={() => {
              deleteButtonOnClick();
            }}
            style={{
              height: "40px",
              padding: "0 20px",
              width: "150px",
            }}
          >
            Yes, Delete
          </Button>
        </Group>
      </div>
    </Modal>
  );
};

export default DeleteBlockedDatesModal;
